import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem } from "@/components/shared/Reveal";
import { MapPin, Navigation as NavIcon, Flag, ArrowRight } from "lucide-react";

const FLOWS = [
  { title: "Standard Delivery", steps: ["Navigate to Pickup", "Navigate to Dropoff"] },
  { title: "Relief Assignment", steps: ["Navigate to Handoff", "Navigate to Dropoff"] },
  { title: "RV Recovery", steps: ["Navigate to RV", "Navigate to Destination"] },
];

export const NavigationSection = () => {
  return (
    <section data-testid="navigation-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-[0.9fr_1.1fr] gap-16 items-start">
        <SectionHeading
          eyebrow="Navigation"
          title="From Assignment to Destination."
          description="After accepting, the driver chooses their preferred navigation app — Google Maps or Waze. RelayRigs automatically hands off the correct destination at each stage, so the driver never copies and pastes an address."
          testId="navigation"
        />

        <RevealStagger className="grid sm:grid-cols-3 gap-5">
          {FLOWS.map((flow) => (
            <RevealItem key={flow.title}>
              <div data-testid={`nav-flow-${flow.title.toLowerCase().replace(/\s+/g, "-")}`} className="bg-rr-surface rounded-2xl p-6 h-full border border-rr-line">
                <h4 className="font-heading font-bold text-rr-navy mb-4">{flow.title}</h4>
                <div className="space-y-3">
                  {flow.steps.map((s, i) => (
                    <div key={s} className="flex items-center gap-2 text-sm font-semibold text-rr-muted">
                      {i === 0 ? <MapPin size={15} className="text-rr-orange" /> : <Flag size={15} className="text-rr-green" />}
                      {s}
                    </div>
                  ))}
                </div>
                <div className="mt-5 flex items-center gap-2 text-xs font-bold text-rr-navy/60">
                  <NavIcon size={13} /> Google Maps <span className="text-rr-line">|</span> Waze
                </div>
              </div>
            </RevealItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
};
